import Vue from 'vue'
import Vuex from 'vuex'
import agency from './modules/agency'
import app from './modules/app'
import caregiver from './modules/caregiver'
import client from './modules/client'
import internaladmin from './modules/internaladmin'
import employee from './modules/employee'
import staffStatus from './modules/staffStatus'
import eventLog from './modules/eventLog'
import config from './modules/config'
import user from './modules/user'
import shift from './modules/shift'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

const store = new Vuex.Store({
  modules: {
    agency,
    app,
    caregiver,
    client,
    user,
    internaladmin,
    employee,
    staffStatus,
    config,
    eventLog,
    shift,
  },
  actions: {
    RESET_STATE ({ commit }) {
      commit('agency/RESET_STATE')
      commit('app/RESET_STATE')
      commit('caregiver/RESET_STATE')
      commit('client/RESET_STATE')
      commit('user/RESET_STATE')
      commit('internaladmin/RESET_STATE')
      commit('employee/RESET_STATE')
      commit('config/RESET_STATE')
      commit('eventLog/RESET_STATE')
      commit('shift/RESET_STATE')
    },
  },
  strict: debug,
})

export default store
